
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5SYww", function(module, exports) {

$parcel$export(module.exports, "PagesItemActions", () => $313e848f91dccb56$export$bbecd2ee2d957a01);
/* PagesItemActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $4NZXC = parcelRequire("4NZXC");

var $1s5hv = parcelRequire("1s5hv");
var $fVUfS = parcelRequire("fVUfS");

var $1cuAd = parcelRequire("1cuAd");

var $fFc6D = parcelRequire("fFc6D");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $5pCWF = parcelRequire("5pCWF");

var $6MlZq = parcelRequire("6MlZq");

var $gz8ZY = parcelRequire("gz8ZY");

var $bwL2u = parcelRequire("bwL2u");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

const $313e848f91dccb56$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rKir-",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("9Dfto"))).SpaceViewsMenu
});
const $313e848f91dccb56$export$bbecd2ee2d957a01 = ({ isLicensed: isLicensed, edition: edition, selection: selection, setSelection: setSelection, spaceKey: spaceKey, expandContentSection: expandContentSection, onItemClick: onItemClick, spaceHasUserContent: spaceHasUserContent, pageTreeFinishedLoading: pageTreeFinishedLoading })=>{
    const intl = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const canShowFolder = selection === 'TREE';
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $gwFzn.useState)(false);
    const [isContextualCreatePopupOpen, setIsContextualCreatePopupOpen] = (0, $gwFzn.useState)(false);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const [{ isMultiSelectActive: isMultiSelectActive }, { enterMultiSelect: enterMultiSelect, exitMultiSelect: exitMultiSelect }] = (0, $bwL2u.useContentTreeSelection)();
    const [isMobile, setIsMobile] = (0, $gwFzn.useState)(false);
    const mediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.md', function onChange(event) {
        // shifting between mobile and desktop size will update isMobile. We can put additional logic here to exit multiselect
        setIsMobile(event.matches);
    });
    (0, $gwFzn.useLayoutEffect)(()=>{
        setIsMobile(mediaQuery?.matches ?? false);
    }, [
        mediaQuery
    ]);
    const isMultiSelectEnabled = edition === 'PREMIUM' && (0, $9wGTI.fg)('confluence_page_tree_with_actions');
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            exitMultiSelect();
            experienceTracker.abort({
                name: (0, $irVI7.BULK_ACTIONS_IN_CONTENT_TREE_EXPERIENCE),
                reason: 'unmounted page'
            });
        };
    }, [
        exitMultiSelect,
        experienceTracker
    ]);
    const spaceViewsMenu = isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($313e848f91dccb56$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition
    }) : null;
    const contextualCreate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5pCWF.ContextualCreateContentPopoverLoader), {
        isContextualCreateFocused: isContextualCreateFocused,
        setIsContextualCreateFocused: setIsContextualCreateFocused,
        shouldShowPopup: isContextualCreatePopupOpen,
        setShouldShowPopup: setIsContextualCreatePopupOpen,
        spaceKey: spaceKey,
        source: "spaceLevelContextualCreate",
        rootCreateButtonStyling: true,
        onItemClick: onItemClick,
        shouldRenderToParent: true,
        hideFolder: !canShowFolder
    }));
    const multiSelectButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))),
        label: intl.formatMessage($313e848f91dccb56$var$i18n.enableMultiSelect),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>{
            expandSideNav();
            expandContentSection?.();
            enterMultiSelect();
        },
        isTooltipDisabled: false,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'multiSelectButton'
            }
        },
        isDisabled: !pageTreeFinishedLoading
    });
    const onExitMultiSelectClick = ()=>{
        exitMultiSelect();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_ACTIONS_IN_CONTENT_TREE_EXPERIENCE),
            reason: 'clicked exit multi-select'
        });
    };
    const exitMultiSelectButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fVUfS.default), {
        "aria-label": intl.formatMessage($313e848f91dccb56$var$i18n.exitMultiSelectLabel),
        onClick: onExitMultiSelectClick,
        xcss: $313e848f91dccb56$var$styles.exit,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'exitMultiSelectButton'
            }
        }
    }, intl.formatMessage($313e848f91dccb56$var$i18n.exitMultiSelect));
    const nav4Actions = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, exitMultiSelectButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, spaceHasUserContent && isMultiSelectEnabled && !isMobile && multiSelectButton, contextualCreate, !isMultiSelectEnabled && spaceViewsMenu);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        "data-vc": "pages-item-actions",
        ...ssrPlaceholderIdProp
    }, isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, nav4Actions) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, spaceViewsMenu, contextualCreate));
};
const $313e848f91dccb56$var$i18n = (0, $2nPZH.defineMessages)({
    exitMultiSelect: {
        id: "space-views.exit-multi-select",
        defaultMessage: "Exit"
    },
    exitMultiSelectLabel: {
        id: "space-views.exit-multi-select-label",
        defaultMessage: "Exit multi-select mode"
    },
    enableMultiSelect: {
        id: "space-views.enable-multi-select",
        defaultMessage: "Select to edit multiple items"
    }
});
const $313e848f91dccb56$var$styles = {
    exit: "_11c82smr _18zr1b66 _1pbykb7n _4t3igktf _bfhk1w7a _syazaqb7 _9oik18uv _1bnx8stv _jf4cnqa1"
};

});
parcelRegister("9Dfto", function(module, exports) {

let $7033c231223f3f50$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7033c231223f3f50$var$load("9CDY0"),
    $7033c231223f3f50$var$load("ffEVr"),
    $7033c231223f3f50$var$load("fC3D2")
]).then(()=>parcelRequire('a0Cao'));

});



//# sourceMappingURL=PagesItemActions.7a9b2690.js.map
